import React from 'react';
import PropTypes from 'prop-types';
import CardRow from '../QuotationHeaderCardRow';
import { Grid } from '@mui/material';
import { Autocomplete, TextField, Card, Button, CollapseCard } from '@totalsoft/rocket-ui';
import LocalOfferIcon from '@mui/icons-material/LocalOffer';
import PlaylistAddCheckIcon from '@mui/icons-material/PlaylistAddCheck';
import { useTranslation } from 'react-i18next';
import { emptyString, emptyArray } from 'constants/defaultValues';
import LinearProgressWrapper from 'components/common/LinearProgressWrapper';
import { QuotationLoadingTitleWrapper } from '../CascoStyles';

export const QuotationGridLoadingComponent = ({ index }) => {
  const { t } = useTranslation();

  return (
    <Grid item xs={12} sm={6} xl={3} key={index}>
      <Card icon={LocalOfferIcon}>
        <Grid container spacing={1}>
          <QuotationLoadingTitleWrapper item xs={12}>
            <LinearProgressWrapper />
          </QuotationLoadingTitleWrapper>
          <Grid container item alignItems='center'>
            <CardRow label={t('Offer.Edit.Casco.Header.ConventionName')} value={<LinearProgressWrapper />} />
            <CardRow label={t('Offer.Edit.Casco.Header.Periodicity')} value={<LinearProgressWrapper />} />
            <CardRow label={t('Offer.Edit.Casco.Header.InsuranceAmount')} value={<LinearProgressWrapper />} />
            <CardRow label={t('Offer.Edit.Casco.Header.Period')} value={<LinearProgressWrapper />} />
            <CardRow label={t('Offer.Edit.Casco.Header.TotalInsuranceAmount')} value={<LinearProgressWrapper loading={true} />} />
          </Grid>
          <Grid item xs={12}>
            <Autocomplete
              id='Partial_Damage_Deductible'
              isSearchable
              fullWidth
              simpleValue
              disabled
              label={t('Offer.Edit.Casco.Header.PartialDamageDeductibleAmount')}
              value={emptyString}
              options={emptyArray}
              onChange={() => {}}
            />
          </Grid>
          <Grid item xs={12}>
            <Autocomplete
              id='Total_Damage_Deductible'
              isSearchable
              fullWidth
              simpleValue
              disabled
              label={t('Offer.Edit.Casco.Header.TotalDamageDeductiblePercent')}
              value={emptyString}
              options={emptyArray}
              onChange={() => {}}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              id='Discount_Amount'
              label={t('Offer.Edit.Casco.Header.DiscountAmountLabel')}
              fullWidth
              isNumeric
              disabled
              value={emptyString}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              id='Discount_Percent'
              label={t('Offer.Edit.Casco.Header.DiscountPercent')}
              fullWidth
              isNumeric
              disabled
              value={emptyString}
            />
          </Grid>
          <Grid item xs={12}>
            <CollapseCard
              icon={PlaylistAddCheckIcon}
              title={t('Offer.Edit.Casco.Risks.Title')}
              expanded={false}
              sx={{ mb: 1 }}
              toggleOnHeaderClick
            />
          </Grid>
          <Grid item xs={12}>
            <CollapseCard
              icon={PlaylistAddCheckIcon}
              title={t('Offer.Edit.Casco.Coefficients.Title')}
              expanded={false}
              toggleOnHeaderClick
            />
          </Grid>
          <Grid item container spacing={2}>
            <Grid item xs={12} md={6}>
              <Button fullWidth id={'Save_Convention_' + index} color='primary' disabled={true}>
                {t('General.Save')}
              </Button>
            </Grid>
            <Grid item xs={12} md={6}>
              <Button fullWidth id={'Select_Convention_' + index} color='primary' disabled={true}>
                {t('General.Select')}
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </Card>
    </Grid>
  );
};

QuotationGridLoadingComponent.propTypes = {
  index: PropTypes.number
};

export default QuotationGridLoadingComponent;
